import { render, staticRenderFns } from "./Plataformas.vue?vue&type=template&id=a0b5f350&scoped=true"
import script from "./Plataformas.vue?vue&type=script&lang=js"
export * from "./Plataformas.vue?vue&type=script&lang=js"
import style0 from "./Plataformas.vue?vue&type=style&index=0&id=a0b5f350&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b5f350",
  null
  
)

export default component.exports